import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { FeatureProp } from '../PropTypes/StandardFeatureProp';
import FeatureCategory from '../components/FeatureCategory';

export const WidgetContainer = ({ standardFeatures }) => {
	return (
		<>
			{standardFeatures.map((feature) => {
				return <FeatureCategory key={feature.key} feature={feature} />;
			})}
		</>
	);
};

WidgetContainer.propTypes = {
	standardFeatures: PropTypes.arrayOf(FeatureProp).isRequired
};

const mapStateToProps = (state) => {
	return {
		standardFeatures: state.standardFeatures
	};
};

export default connect(mapStateToProps)(WidgetContainer);
